import React from 'react';
import styled from 'styled-components';
import classNames from 'classnames';

import AggregateCheckBox from '../../../../../containers/dashboards/cards/builder/users/AggregateCheckBox';
import UsersColumns from '../../../../users/UsersColumns';
import EventSelector from '../../../../users/EventSelector';
import UsersFilter from '../../../../../containers/dashboards/cards/builder/users/UsersFilter';

const UsersViewContainer = styled.div`
  display: flex;
  align-items: stretch;
  height: 100%;
  overflow-y: auto;

  .container {
    width: 100%;
    height: 100%;
  }

  .sub-container {
    height: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: row;
    width: 100%;
  }

  .main {
    width: 100%;
    padding: 20px;
    overflow: auto;
    display: flex;
    justify-content: space-between;
    flex-shrink: 0;
  }

  .main-content {
    margin: 0 0 15px 0;
  }

  .filter-container {
    display: flex;
  }

  .options-container {
    margin-left: 40px;
    width: 40%;
  }
`;

const UsersView = ({
  metainf,
  columns,
  setUsersEventColumnValue,
  deleteUsersEventColumn,
  addUsersEventColumn,
  unit,
  showNotValidFields,
  events,
  event,
  changeUsersEvent,
}) => (
  <UsersViewContainer>
    <div className={classNames('st-users-view-dashboard', 'container')}>
      <div className="sub-container">
        <div className="main">
          <div className="main-content">
            <span className="title">Event</span>
            <EventSelector
              event={event}
              changeUsersEvent={changeUsersEvent}
              events={events}
              showNotValidFields={showNotValidFields}
            />
            {event ? (
              <div className="filter-container">
                <UsersFilter unit={unit} />
              </div>
            ) : undefined}
          </div>
          <div className="options-container">
            <UsersColumns
              columns={columns}
              setUsersEventColumnValue={setUsersEventColumnValue}
              metainf={metainf}
              deleteUsersEventColumn={deleteUsersEventColumn}
              addUsersEventColumn={addUsersEventColumn}
            />
            <div>
              <AggregateCheckBox unit={unit} />
            </div>
          </div>
        </div>
      </div>
    </div>
  </UsersViewContainer>
);

export default UsersView;
